//--------------------------------------------------
// imported classes
//--------------------------------------------------
const Match = require('@/tbs/model/to/Match')
const ClassFunc = require('@/tbs/util/ClassFunc')

/**
 * The Player class works as the player translator.
 */
const tbs_model_to_MatchSignupPayment = function() {
    //--------------------------------------------------
    // super method for the base class
    //--------------------------------------------------
    ClassFunc.super(this, Match, arguments);
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_model_to_MatchSignupPayment.prototype = {
    'online-signup': '在线报名',
    'limited-free': '限时免费',
    'data-collection': '资料收集',
    'audit-information': '审核信息',
    'rapid-build-team': '快速建队',
    'signup-data': '报名资料',
    'signup-data-config': '报名资料设置',
    'online-payment': '在线缴费',
    'withdraw-anytime': '随时提现',
    'rapid-transfer': 'T+1到账',
    'open': '开启',
    'match-signup-start-time-label': '报名开始时间',
    'match-signup-end-time-label': '报名结束时间',
    'match-signup-status-type-2': '报名中',
    'signup-empty-hint': '暂无报名，请新建报名链接',
    'create-signup-link': '新建报名链接',
    'online-signup-table-label': '在线报名表',
    'online-signup-table-desc-1': '队长报名，队员填写参赛信息',
    'online-signup-table-desc-2': '赛事内仅支持创建一个在线报名表链接',
    'online-payment-table-label': '比赛报名+缴费',
    'online-payment-table-desc': '设置费用，定金暂时扣除，信息收集',
    'team-signup-data': '队伍报名资料',
    'member-signup-data': '队员报名资料',
    'contestant-signup-data': '参赛队员限制',
    'staff-signup-data': '工作人员报名',
    'team-number': '队伍人数',
    'gener-restriction': '性别限制',
    'age-restriction': '年龄段',
    'staff-number': '工作人员数',
    'staff-signup-off-hint': '暂未开启工作人员报名',
    'gender-restriction-type-1': '不限制',
    'gender-restriction-type-2': '仅男队员',
    'gender-restriction-type-3': '仅女队员',
    'gender-restriction-type-4': '混合参赛',
    'male-member-number': '男队员人数',
    'female-member-number': '女队员人数',
    'birth-period': '$fYear${year}$fMonth${month}$fDate${dat}-$bYear${year}$bMonth${month}$bDate${dat}之间出生',
    'birth-no-less': '$year${year}$month${month}$date${dat}后出生',
    'birth-no-more': '$year${year}$month${month}$date${dat}前出生',
    'birth-earliest-date': '最早出生日期',
    'birth-latest-date': '最晚出生日期',
    'fill-identification-num': '需填报证件号',
    'upload-photo': '上传照片',
    'signup-staff-role': '允许报名职务',
    'staff-role-type-1': '领队',
    'staff-role-type-2': '主教练',
    'staff-role-type-3': '教练',
    'staff-role-type-4': '队医',
    'staff-role-type-5': '其他',
    'match-signup-name-placeholder': '清楚描述赛事报名的名称（20字以内）',
    'match-signup-name-required': '请输入赛事报名名称',
    'match-signup-desc-placeholder': '描述一下赛事的特点、介绍、说明~~帮助大家更好的了解报名信息',
    'upload-nice-photo': '上传优质图片',
    'match-signup-start-time': '开始时间（可选）',
    'match-signup-end-time': '结束时间',
    'match-signup-end-time-required': '请选择报名结束时间',
    'match-signup-frozen-time': '调整截止（可选）',
    'match-signup-team-total': '招募队伍数',
    'match-signup-team-total-label': '招募队伍数量',
    'signup-team-config-type-1': '队伍名称',
    'signup-team-config-type-2': '队伍简称',
    'signup-team-config-type-3': '队伍联系人',
    'signup-team-config-type-4': '联系方式',
    'signup-team-config-type-5': '队徽',
    'signup-team-config-type-6': '代表团',
    'signup-team-config-type-7': '主场服颜色',
    'signup-team-config-type-7-desc': '上衣和裤子两个选项',
    'signup-team-config-type-8': '客场服颜色',
    'signup-team-config-type-8-desc': '上衣和裤子两个选项',
    'signup-team-config-type-9': '比赛服颜色',
    'signup-team-config-type-9-desc': '包含队员和守门员比赛服颜色',
    'signup-team-config-type-10': '队服款式',
    'signup-team-config-type-10-desc': '支持队伍报名时选择队服款式',
    'signup-team-config-type-11': '队伍保险凭证',
    'signup-team-config-type-11-desc': '需要队伍报名时，上传保险凭证',
    'signup-member-config-type-1': '姓名',
    'signup-member-config-type-2': '队员号码',
    'signup-member-config-type-3': '联系方式',
    'signup-member-config-type-4': '性别',
    'signup-member-config-type-5': '出生年月',
    'signup-member-config-type-6': '证件信息',
    'signup-member-config-type-6-1': '身份证',
    'signup-member-config-type-6-2': '学籍卡',
    'signup-member-config-type-6-3': '护照',
    'signup-member-config-type-6-4': '港澳通行证',
    'signup-member-config-type-6-5': '台胞证',
    'signup-member-config-type-6-11': '港澳回乡证',
    'signup-member-config-type-7': '身高',
    'signup-member-config-type-8': '体重',
    'signup-member-config-type-9': '队服尺码',
    'signup-member-config-type-10': '运动鞋尺码',
    'signup-member-config-type-11': '家长姓名',
    'signup-member-config-type-12': '家长联系方式',
    'signup-member-config-type-13': '在读学校',
    'signup-member-config-type-14': '保险证明',
    'signup-member-config-type-15': '场上位置',
    'signup-member-config-type-16': '资质证明',
    'signup-member-config-type-17': '队服姓名',
    'signup-member-config-type-18': '队内职务',
    'signup-member-config-type-19': '所在城市',
    'signup-member-config-type-20': '民族',
    'signup-member-config-type-21': '国籍',
    'signup-member-config-type-22': '工作单位',
    'signup-member-config-type-23': '职业',
    'signup-member-config-type-24': '所属队伍',
    'signup-member-config-type-25': '注册证号',
    'signup-member-config-type-26': '是否职业选手',
    'signup-member-config-type-27': '紧急联系人',
    'signup-member-config-type-28': '备注',
    'other-data-item': '其他资料项',
    'other-data-tab-type-1': '身体数据',
    'other-data-tab-type-2': '青少年',
    'other-data-tab-type-3': '参赛信息',
    'other-data-tab-type-4': '个人信息',
    'other-data-tab-type-5': '其他',
    'match-signup-info': '报名信息',
    'match-signup-intro': '简介说明',
    'match-rule': '赛事规则',
    'substitution-type1-restriction-type1': '全场最多换$num人',
    'substitution-type1-restriction-type2': '每半场换$num人',
    'substitution-on-yes': '换下可再换上',
    'substitution-on-no': '换下不可再换上',
    'substitution-half-count-yes': '半场换人算次数',
    'substitution-half-count-no': '半场换人不算次数',
    'substitution-once-num': '单次最多$num人',
    'match-signup-requirements': '报名要求',
    'match-team-data-collect': '队伍资料',
    'match-member-data-collect': '队员资料',
    'match-signup-photo-empty-hint': '暂无简介说明',
}

//--------------------------------------------------
// extends the Match
//--------------------------------------------------
ClassFunc.extend(tbs_model_to_MatchSignupPayment, Match);

module.exports = tbs_model_to_MatchSignupPayment